import styled from 'styled-components';
import { observer } from 'mobx-react-lite';
import React from 'react';

const TextArea = styled.textarea`
  resize: ${(p) => (p.resize ? 'vertical' : 'none')};
  width: 100%;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.04);
  border: ${(p) => (p.error ? `1px solid ${p.theme.errorColor}` : '1px solid transparent')};
  ${(p) => p.bold && 'font-weight: bold'};
  font-size: 16px;
  color: ${(p) => p.theme.formInputColor || '#383838'};
  padding: 6px 12px 6px 12px;
  line-height: 22px;
  box-sizing: border-box;
  height: 8em;
  ${(p) => p.disabled && 'opacity: 0.65'};

  :focus {
    ${(p) => !p.error && `border: 1px solid ${p.theme.primaryColor}`};
    border-radius: 4px;
    outline: none;
  }
`;

const Error = styled.span`
  color: ${(props) => props.theme.errorColor};
  font-size: 12px;
`;

export default observer((props) => {
  return (
    <>
      <TextArea {...props} spellCheck="false" />
      <Error>{props.error}</Error>
    </>
  );
});
